import { FormattedMessage as FM } from "react-intl";

import Dialog from "componentsv2/modal/Dialog";
import { QuestionIcon, WarningIcon, CheckIcon } from "components/Icons";

const TYPE_ICON = {
  ask: <QuestionIcon className="mx-auto fill-current text-sky-400 h-16 w-16" />,
  success: (
    <CheckIcon className="mx-auto fill-current text-sky-400 h-16 w-16" />
  ),
  warning: (
    <WarningIcon className="mx-auto fill-current text-orange-400 h-16 w-16" />
  ),
  error: (
    <WarningIcon className="mx-auto fill-current text-rose-400 h-16 w-16" />
  ),
  no: (
    <WarningIcon className="mx-auto fill-current text-neutral-900 h-16 w-16" />
  ),
};

function ModalMsg({ openModal, attrs }) {
  if (!attrs.value) return;

  const { type, msg, buttons } = attrs.value;

  let icon = null;
  if (type) {
    icon = TYPE_ICON[type];
  }

  function handleClose() {
    openModal.value = false;
  }

  return (
    <Dialog
      size="w-1/3"
      openModal={openModal}
      handleClose={handleClose}
      buttons={buttons}
    >
      {icon}
      <div className="flex mt-4 mb-6 h-full text-neutral-800 text-md">
        <div className="mx-auto">
          <FM id={msg}></FM>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalMsg;
